module.exports = __webpack_public_path__ + "img/icon_05.e4d67429.png";